export default (params) => ({
  trigger: {
    name: 'product_plus.show_product_plus',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'vendor_free_with',
          'nespresso',
          'norton',
          'free_washing',
          'free_drying',
        ],
      },
    },
    event: {
      name: 'show_content',
    },
    nonInt: true,
  },
});
